const baseURL = `${process.env.VUE_APP_SERVER_URL}/RedeCredenciada`;

export async function ObterPlanosAnonimo() {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterPlanos`
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterPlanos", error.message);
      return error;
    });
}

export async function ObterTipoAtendimentoAnonimo({ rede }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterTipoAtendimentoAnonimo`,
      query: { rede }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterTipoAtendimentoAnonimo", error.message);
      return error;
    });
}

export async function ObterEspecialidadesAnonimo({ rede, tipoAtendimento, inativos, nomeEspecialidade }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterEspecialidadesAnonimo`,
      query: {
        rede,
        tipoAtendimento,
        inativos,
        nomeEspecialidade
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterEspecialidadesAnonimo", error.message);
      return error;
    });
}

export async function ObterRegioesAnonimo({ rede, tipoAtendimento, codigoEspecialidade, subEspecialidade, inativos }) {
  const query = {
    rede,
    tipoAtendimento,
    codigoEspecialidade,
    subEspecialidade,
    inativos
  };
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterRegioesAnonimo`,
      query
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterRegioesAnonimo", error.message);
      return error;
    });
}

export async function ObterLimiteExamesAnonimo() {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterLimiteExamesAnonimo`
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterLimiteExamesAnonimo", error.message);
      return error;
    });
}

export async function BuscarEnderecoReferenciaAnonimo({ tipoEndereco, latitude, longitude }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarEnderecoReferenciaAnonimo`,
      query: {
        tipoEndereco,
        latitude,
        longitude
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarEnderecoReferenciaAnonimo", error.message);
      return error;
    });
}

export async function BuscarEnderecoReferenciaV2Anonimo({ tipoEndereco, latitude, longitude }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarEnderecoReferenciaV2Anonimo`,
      query: {
        tipoEndereco,
        latitude,
        longitude
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarEnderecoReferenciaV2Anonimo", error.message);
      return error;
    });
}

export async function BuscarPelaProximidadeAtualAnonimo({
  rede,
  tipoAtendimento,
  codigoEspecialidade,
  subEspecialidade,
  latitude,
  longitude,
  inativos
}) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarPelaProximidadeAtualAnonimo`,
      query: {
        rede,
        tipoAtendimento,
        codigoEspecialidade,
        subEspecialidade,
        latitude,
        longitude,
        inativos
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarPelaProximidadeAtualAnonimo", error.message);
      return error;
    });
}

export async function BuscarPorNomeAnonimo({ nome, inativos }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarPorNomeAnonimo`,
      query: {
        nome,
        inativos
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarPorNomeAnonimo", error.message);
      return error;
    });
}

export async function BuscarPorProximidadeAnonimo({
  rede,
  tipoAtendimento,
  codigoEspecialidade,
  buscaProximidadeTipo,
  inativos
}) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarPorProximidadeAnonimo`,
      query: {
        rede,
        tipoAtendimento,
        codigoEspecialidade,
        buscaProximidadeTipo,
        inativos
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarPorProximidadeAnonimo", error.message);
      return error;
    });
}

export async function BuscarPorRegiaoAnonimo({
  rede,
  tipoAtendimento,
  codigoEspecialidade,
  subEspecialidade,
  codigoEstado,
  cidade,
  bairro,
  inativos
}) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/BuscarPorRegiaoAnonimo`,
      query: {
        rede,
        tipoAtendimento,
        codigoEspecialidade,
        subEspecialidade,
        codigoEstado,
        cidade,
        bairro,
        inativos
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("BuscarPorRegiaoAnonimo", error.message);
      return error;
    });
}

export async function DetalhePrestadorAnonimo({ rede, codigoPrestador, srEndereco, inativos, completo }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/DetalhePrestadorAnonimo`,
      query: {
        rede,
        codigoPrestador,
        srEndereco,
        inativos,
        completo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("DetalhePrestadorAnonimo", error.message);
      return error;
    });
}

export async function ObterPlanosAtendidos({ rede, codigoPrestador }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterPlanosAtendidos`,
      query: { rede, codigoPrestador }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterPlanosAtendidos", error.message);
      return error;
    });
}

export async function ObterPlanosCategoriasAnonimo({ linha, codPlano }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterPlanoCategoria`,
      query: { linha, codPlano }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterPlanoCategoria", error.message);
      return error;
    });
}
